function BackIcon() {
  return (
    <svg
      aria-hidden="true"
      className="photo-select-back-icon"
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <path
        d="M15 18 9 12l6-6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg
      aria-hidden="true"
      className="photo-select-chevron-right"
      fill="none"
      height="8"
      viewBox="0 0 4 8"
      width="4"
    >
      <path
        d="M0.75 1 3.25 4 0.75 7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg aria-hidden="true" fill="none" height="24" viewBox="0 0 24 24" width="24">
      <path
        d="M6 6l12 12M18 6 6 18"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

function PlusIcon() {
  return (
    <svg
      aria-hidden="true"
      className="photo-select-plus-icon"
      fill="none"
      height="12"
      viewBox="0 0 12 12"
      width="12"
    >
      <path
        d="M6 2.5v7M2.5 6h7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </svg>
  );
}

function SelectArrowIcon() {
  return (
    <svg
      aria-hidden="true"
      className="photo-select-arrow"
      fill="none"
      height="7"
      viewBox="0 0 14 7"
      width="14"
    >
      <path
        d="M1 1 7 6l6-5"
        stroke="#7D7D7D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
      />
    </svg>
  );
}

export { BackIcon, ChevronRightIcon, CloseIcon, PlusIcon, SelectArrowIcon };
